import type { LogLevel } from "@agoda/messaging-client";
import { getAgoda } from "libs/analytics/functions/agoda.homes";
import { messagingClient } from "libs/analytics/functions/messagingClient";

const log = (level: LogLevel) => (message: string | number) => {
    const agodaHomes = getAgoda();

    // @ts-expect-error eventData can actually accept any type more than string
    const measurement = messagingClient.create("log", {
        level,
        message,
        applicationName: "property-onboarding-clientside",
        url: window.location.href,
        eventdata: {
            authUserId: agodaHomes.authUserId,
            propertyId: agodaHomes.propertyId,
            memberId: agodaHomes.memberId,
            userId: agodaHomes.userId,
            sessionId: agodaHomes.sessionId,
            cultureCode: agodaHomes.language,
            currency: agodaHomes.currency,
            webServerName: agodaHomes.webServerName,
            isInternalUser: agodaHomes.isInternalUser,
        },
    });
    messagingClient.send(measurement);
};

export const reporter = {
    error: log("error"),
    warn: log("warn"),
    debug: log("debug"),
    info: log("info"),
};
